import { render, staticRenderFns } from "./ListAccessory.vue?vue&type=template&id=c8afb1b4&scoped=true"
import script from "./ListAccessory.vue?vue&type=script&lang=js"
export * from "./ListAccessory.vue?vue&type=script&lang=js"
import style0 from "./ListAccessory.vue?vue&type=style&index=0&id=c8afb1b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8afb1b4",
  null
  
)

export default component.exports